import { autoinject } from "aurelia-dependency-injection";
import { PowerBi } from "../../../modules/rightship-insights/powerbi/powerbi-report/powerbi";
import { ReportGuids } from "../../../../../constants/reports/reports.constants";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { PowerBiService } from "../../../../../services/power-bi/power-bi.service";
import { ReportsService } from "../../../../../services/reports/reports.service";
import { Router } from "aurelia-router";
import { GoogleAnalyticsService } from '@rightship-tech/common-ui/services/analytics/google-analytics.service';
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";

@autoinject
export class GhgRatingChangeReport extends PowerBi {

    constructor(powerBiService: PowerBiService, reportsService: ReportsService, router: Router, userClaimService: UserClaimsService,
        googleAnalyticsService: GoogleAnalyticsService, protected configService: ConfigService) {
        super(powerBiService, reportsService, router, userClaimService, googleAnalyticsService, configService);
    }

    requestEnvironmentalVerification() {
        window.open(this.configService.config.urls.rightShipPlatformUrl + "/environmental-review");
    }

    async activate(): Promise<void> {
        await super.activate({
            guid: ReportGuids.GhgRatingChangeReportGuid,
            entityId: null,
            entityTypeId: null,
            id: null,
            title: null
        });
    }
}